import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProblemsSection from './components/ProblemsSection';
import StrengthsSection from './components/StrengthsSection';
import CoursesSection from './components/CoursesSection';
import ResultsSection from './components/ResultsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import TrialFlowSection from './components/TrialFlowSection';
import CTASection from './components/CTASection';
import AccessSection from './components/AccessSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ProblemsSection />
        <StrengthsSection />
        <CoursesSection />
        <ResultsSection />
        <TestimonialsSection />
        <FAQSection />
        <TrialFlowSection />
        <CTASection />
        <AccessSection />
      </main>
      <Footer />
    </div>
  );
}
